import { Link } from "react-router-dom";
import PageHeader from "../shared-components/PageHeader";
import ScannerIcon from "../shared-components/icons/ScannerIcon";
import TaskAssignment from "./assignment/TaskAssignment";

const WorkflowRoles = () => {
  return (
    <>
      <PageHeader>
        <h2 className="text-slate-900 text-2xl font-extrabold tracking-tight py-6 mt-4">
          Analyst Task Assignment (Manual Task Only)
        </h2>
        <div>
          <Link to="/workflows/checkassignment">
            <div className="flex items-center justify-center gap-3 bg-green-600 rounded-md py-3 px-2 text-white w-80 mt-2">
              <ScannerIcon />
              Manage Checktype Assignments
            </div>
          </Link>
        </div>
      </PageHeader>

      <div className="mb-48">
        <TaskAssignment />
      </div>
    </>
  );
};

export default WorkflowRoles;
